/*
 * Portions of this code are from Novel (https://github.com/steven-tey/novel)
 * Copyright (c) 2023 Steven Tey
 * Licensed under the Apache License, Version 2.0
 */

import type { Range } from '@tiptap/core'
import { atom } from 'jotai'

export const queryAtom = atom('')
export const rangeAtom = atom<Range | null>(null)
